export const APP_LOCALE = 'en-US';

export function formatAppDate(date, options) {
  return date.toLocaleDateString(APP_LOCALE, options);
}

export function formatAppTime(date, options) {
  return date.toLocaleTimeString(APP_LOCALE, options);
}